/**
 * A/B test variant store.
 *
 * Assignments load once after login via `loadExperiments()` and are read
 * synchronously by components via `getVariant(key)`. Only running + paused
 * experiments appear in the map — ended ones are filtered server-side.
 */

import { api } from '$shared/api';

let assignments = $state<Record<string, string>>({});
let loaded = $state(false);

export async function loadExperiments(): Promise<void> {
  if (loaded) return;
  try {
    const data = await api.get<Record<string, string>>('/experiments/assignments');
    assignments = data ?? {};
  } catch {
    assignments = {};
  }
  loaded = true;
}

export function getVariant(key: string): string | null {
  return assignments[key] ?? null;
}

export function resetExperiments(): void {
  assignments = {};
  loaded = false;
}
